"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
interface Specialist {
  id: number;
  name: string;
  initials: string;
  role: string;
  expertise: string;
}
const specialists: Specialist[] = [{
  id: 1,
  name: "Toni Gorb",
  initials: "TG",
  role: "Especialista",
  expertise: "Direção Audiovisual & Podcast"
}, {
  id: 2,
  name: "Paulo Brito",
  initials: "PB",
  role: "Especialista",
  expertise: "Estratégia Digital & Produção"
}, {
  id: 3,
  name: "Guilherme Brito",
  initials: "GB",
  role: "Especialista",
  expertise: "Tráfego Pago & Performance"
}];
export default function Team() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  return <section id="teammembers" data-nav="light" className="bg-background text-foreground py-24 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 sm:mb-20">
          <h2 className="font-default text-3xl sm:text-4xl font-semibold tracking-tight text-foreground">
            Nossa Equipe
          </h2>
          <p className="mt-4 text-base sm:text-lg text-muted-foreground">
            Conheça os especialistas por trás dos projetos da ITC+
          </p>
        </div>

        {/* 3-Column Specialists Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-50px"
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {specialists.map((specialist, index) => <motion.div key={specialist.id} data-index={index} variants={itemVariants} whileHover={shouldReduceMotion ? {} : {
          y: -4
        }} transition={{
          duration: 0.2
        }}>
              <Card className="h-full border border-border bg-card text-card-foreground shadow-xs hover:shadow-md rounded-2xl transition-[box-shadow,border-color] duration-300">
                <CardContent className="flex flex-col items-center text-center p-8 sm:p-10">
                  {/* 80px Circular Text Avatar Badge */}
                  <div className="mb-6 flex items-center justify-center">
                    <SafeHydrate><Avatar className="size-20 ring-4 ring-primary/10">
                      <AvatarFallback className="bg-primary text-primary-foreground text-xl font-bold tracking-normal">
                        {specialist.initials}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                  </div>

                  {/* Specialist Details */}
                  <h3 className="font-default text-xl font-medium text-foreground tracking-tight">
                    {specialist.name}
                  </h3>
                  <span className="mt-1 text-sm font-normal text-muted-foreground">
                    {specialist.role}
                  </span>

                  <div className="mt-4 pt-4 border-t border-border/60 w-full">
                    <p className="text-xs text-muted-foreground uppercase tracking-wider font-medium">
                      {specialist.expertise}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}